// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn_content[data-v-7be74123]:focus,button[data-v-7be74123]:focus{outline:none}.lol[data-v-7be74123]{color:#fff!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
